import { defineSlotRecipe } from "@pandacss/dev";
import { fieldDefaultRecipeDefinition } from "./utils/fieldDefaultRecipeDefinition";
import textFieldStyles from "./utils/textFieldStyles";

export const aromaTextarea = defineSlotRecipe({
  className: "aroma-textarea",
  jsx: ["Textarea"],
  slots: ["textarea", "container"],
  base: {
    container: {
      ...fieldDefaultRecipeDefinition.base,
      borderRadius: "l",
      padding: "{sizes.4xs} {sizes.3xs}",
      alignItems: "flex-start",
      "&:has([data-part=textarea]:focus-visible)": {
        shadow: "none",
        borderColor: "border.brand-bold",
      },
      _disabled: {
        cursor: "not-allowed",
      },
    },
    textarea: {
      ...textFieldStyles,
      resize: "vertical",
      textStyle: "paragraph.m.regular",
      width: "100%",
      border: "none",
      outline: "none",
      _disabled: {
        cursor: "not-allowed",
      },
    },
  },
  variants: {
    status: { ...fieldDefaultRecipeDefinition.variants?.status },
  },
});
